import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { ResearchMain } from './index.style'
import Spacer from '@components/Spacer'

const Research = ({ content }) => {
  useEffect(() => {
    if (window.rtPortal) window.rtPortal.initialise()
  }, [])

  return (
    <ResearchMain>
      <iframe
        title="Access to Research"
        id="portal-frame"
        min-height="800px"
        data-sourceurl="https://www.research-tree.com/erf/embed/research/b7053165-b9fb-413b-b5ef-4fe376990fe5?"
        src="https://www.research-tree.com/working.html"
        frameBorder="0"
        width="100%"
        scrolling="no"
      ></iframe>
      <Spacer size={[40, 80]} />
    </ResearchMain>
  )
}

Research.propTypes = {
  content: PropTypes.object,
}

export default Research
